export enum AsanSignActionTypes {
    FETCH_ASAN_SIGN_REQUEST = 'FETCH_ASAN_SIGN_REQUEST',
    FETCH_ASAN_SIGN_SUCCESS = 'FETCH_ASAN_SIGN_SUCCESS',
    FETCH_ASAN_SIGN_FAILED = 'FETCH_ASAN_SIGN_FAILED',
}

export interface AsanRefuceRequest {
  transactionId: string
}

export interface AsanSignResponse {
    verificationCode: string
    transactionId: string
    fullName: string
}

export interface SingFile {
  name: string
  mimeType: string
  encodedBytes: string
}

export interface AsanSignRequest {
  files: SingFile[]
  docType: string
}

export interface AsanSignState {
    status: 'idle' | 'loading' | 'success' | 'failed',
    error: null | any,
    loading: boolean,
    data: null | AsanSignResponse,
}

export interface FetchAsanSignRequest {
  type: AsanSignActionTypes.FETCH_ASAN_SIGN_REQUEST
}

export interface FetchAsanSignSuccess {
  type: AsanSignActionTypes.FETCH_ASAN_SIGN_SUCCESS
  payload: AsanSignResponse
}

export interface FetchAsanSignFailed {
  type: AsanSignActionTypes.FETCH_ASAN_SIGN_FAILED
  payload: string
}

export type AsanSignActions = FetchAsanSignRequest | FetchAsanSignSuccess | FetchAsanSignFailed